import React, { useState } from "react";
import Input from "../FormComponents/Input";
import Label from "../FormComponents/Label";
import { AddAndDeleteInlineIcon } from "../BuilderComponents/Preview/IconPreview";

const EditLabel = ({ editElementData, setEditElementData }) => {
  const handleIconChange = (icon) => {
    setEditElementData({ ...editElementData, icon });
  };

  const handleNameChange = (name) => {
    setEditElementData({ ...editElementData, name });
  };

  // const handleFieldClassName = (heading, selectedValue) => {
  //   setEditElementData({ ...editElementData, className: { ...editElementData.className, [heading]: selectedValue } });
  // };

  // const handleLabelStyle = (data) => {
  //   setEditElementData({ ...editElementData, inline_style: data });
  // };
  // const handleCustomCss = (e) => {
  //   const { name, value } = e.target;
  //   setEditElementData({ ...editElementData, [name]: value });
  // };
  return (
    <EditLabelWithIcon
      label="Label"
      icon={editElementData.icon}
      onIconChange={handleIconChange}
      name={editElementData.name}
      onNameChange={handleNameChange}
      placeholder="Enter Label Name"
    />
  );
};

const EditLabelWithIcon = ({ label, icon, onIconChange, name, onNameChange, placeholder }) => {
  const [selectedIcon, setSelectedIcon] = useState(icon || "");

  const handleIconChange = (data) => {
    setSelectedIcon(data);
    if (onIconChange) onIconChange(data);
  };

  const handleNameChange = (e) => {
    if (onNameChange) onNameChange(e.target.value);
  };

  return (
    <div className="flex_column gap_2">
      <Label>{label}</Label>
      <div className="d_flex">
        <AddAndDeleteInlineIcon icon={selectedIcon} callbackFunction={handleIconChange} />
        <Input
          value={name}
          onChange={handleNameChange}
          type="text"
          inputClassName="border_left_none outline_none"
          placeholder={placeholder || (selectedIcon ? "" : "Enter Label Name")}
        />
      </div>
    </div>
  );
};

export { EditLabelWithIcon };

export default EditLabel;
